import { apiClientGeral } from '@/plugins/axios'

export default {
  getSipConfig() {
    return apiClientGeral().get('/sipconfig')
  },

  putSipConfig(form) {
    return apiClientGeral().put('/sipconfig', form)
  },
}
